<i18n>
de:
  recommendations: "Weitere Angebote von {nickname}"

en:
  recommendations: "More offers from {nickname}"
</i18n>

<template>
  <div v-if="recommendations.length" class="pt-10 lg:pt-0">
    <h2 class="text-secondary-400 text-xl pb-4">
      {{ $t('recommendations', { nickname: nickname }) }}
    </h2>
    <div>
      <ItemSwiper :items="recommendations" :slideCount="2" />
    </div>
  </div>
</template>

<script>
import ItemSwiper from '@/components/itemSwiper.vue'
import { sync } from 'vuex-pathify'
export default {
  props: ['recommendations', 'sidebar'],
  components: { ItemSwiper },
  computed: {
    nickname: sync('reward/nickname')
  }
}
</script>
